// Proje Yönetimi sayfası ve Tailwind'e geçen modalları için metinler.
const projectManagement = {
  title: 'Proje Yönetimi',
  subtitle: 'Projeleri arayın, filtreleyin; ekip, ziyaret, hasta ve dosyalarını yönetin.',
  listLabel: 'Proje listesi',
  yes: 'Evet',
  no: 'Hayır',
  status: {
    active: 'Aktif',
    inactive: 'Pasif',
    all: 'Tümü',
  },
  stats: {
    total: 'Toplam Proje',
    totalShort: 'Toplam',
    active: 'Aktif Proje',
    activeShort: 'Aktif',
    inactive: 'Pasif Proje',
    inactiveShort: 'Pasif',
    share: 'Tüm projeler içindeki payı: %{{percent}}',
  },
  actions: {
    add: 'Yeni Proje Ekle',
    addTest: 'Yeni Test Projesi Ekle',
    stats: 'İstatistikler',
    download: 'Tabloyu İndir',
    downloadHint: 'Tüm projeleri tabloda görünen sütunlarla Excel olarak indir',
  },
  toggles: {
    dueSoon: 'Bitişi yaklaşanlar',
    dueSoonHint: 'Bitiş tarihi önümüzdeki bir ay içinde olan projeler',
    testOnly: 'Test projeleri',
    testOnlyHint: 'Yalnızca test projelerini göster',
  },
  search: {
    placeholder: 'Müşteri, proje veya departman ara…',
    placeholderShort: 'Proje ara…',
    label: 'Proje ara (en az 3 karakter)',
  },
  columns: {
    customer: 'Müşteri',
    titleShort: 'Başlık (Kısa)',
    projectPhase: 'Proje Aşaması',
    projectStatus: 'Proje Durumu',
    protocolNumber: 'Protokol Numarası',
    ethicsCommitteeDate: 'Etik Kurul Tarihi',
    ethicsCommitteeNumber: 'Etik Kurul Numarası',
    ethicsCommitteePlace: 'Etik Kurul Yeri',
    firstInvoiceDate: 'İlk Fatura Tarihi',
    paymentFrequency: 'Ödeme Sıklığı',
    projectCentersType: 'Proje Merkezi Tipi',
    projectDesign: 'Proje Design',
    projectDate: 'Proje Tarihi',
    projectDepartment: 'Proje Departmanı',
    projectDueDate: 'Proje Bitiş Tarihi',
    coordinatorAcademician: 'Koordinatör Akademisyen',
    sbFirstApprovalDate: 'SB İlk Onay Tarihi',
    sbFirstApprovalNumber: 'SB İlk Onay Numarası',
    sbProjectNumber: 'SB Proje Numarası',
    titleLong: 'Başlık (Uzun)',
    isCurrencyFixed: 'Kur Sabitlemesi',
    fixedCurrencyRate: 'Sabit Kur (Kaçtan?)',
  },
  phases: {
    initiation: 'Başlangıç',
    planning: 'Planlama',
    execution: 'Yürütme',
    monitoring: 'İzleme ve Kontrol',
    closing: 'Kapanış',
    completed: 'Tamamlandı',
    phase1: 'Faz I',
    phase2: 'Faz II',
    phase3: 'Faz III',
    lowRisk: 'Düşük Riskli Bilimsel Çalışma',
    adaptive12: 'Adaptif (Faz I/II)',
    adaptive13: 'Adaptif (Faz I/III)',
    adaptive23: 'Adaptif (Faz II/III)',
    healthClaim: 'Sağlık Beyanlı Ürün/Yöntem',
    observational: 'Gözlemsel Çalışma',
    stemCell: 'Kök Hücre Araştırması',
  },
  designs: {
    doubleBlind: 'Çift Kör',
    openLabel: 'Open Label (Açık Etiketli)',
    hybrid: 'Hibrit',
  },
  badges: {
    finished: 'Bitti',
    test: 'Test',
  },
  due: {
    daysLeft_one: '{{count}} gün kaldı',
    daysLeft_other: '{{count}} gün kaldı',
    today: 'Bugün bitiyor',
    overdue_one: '{{count}} gün geçti',
    overdue_other: '{{count}} gün geçti',
  },
  table: {
    empty: 'Filtrelere uygun proje bulunamadı',
  },
  pagination: {
    rangeOf: '/ {{total}} proje',
    ofTotal: 'toplam {{total}} proje içinden',
  },
  panel: {
    label: 'Proje ayrıntıları',
    heading: 'Proje',
    card: 'Proje Kartı',
    edit: 'Düzenle',
    workers: 'Çalışanlar',
    visits: 'Ziyaretler',
    patients: 'Hastalar',
    files: 'Dosyalar',
    screenFail: 'Screen Fail',
    finish: 'Projeyi Bitir',
    unfinish: 'Bitişi Geri Al',
    finishHint: 'Projeyi bitmiş olarak işaretler; proje aktif kalır',
    deactivate: 'Pasife Al',
    activate: 'Aktife Al',
    statusHint: 'Proje durumunu değiştir (Aktif/Pasif)',
  },
  confirm: {
    title: 'Onay Gerekli',
    cancel: 'İptal',
    confirm: 'Evet, Eminim',
    status: "Proje Durumunu '{{status}}' olarak değiştirmek istediğinizden emin misiniz?",
    finish: '"{{name}}" projesini bitmiş olarak işaretlemek istediğinize emin misiniz? Proje aktif kalmaya devam edecek.',
    unfinish: '"{{name}}" projesinin "bitti" işaretini kaldırmak istediğinize emin misiniz?',
    projectFallback: 'Proje',
  },
  toast: {
    loadError: 'Projeler yüklenirken hata oluştu!',
    excelPreparing: 'Excel dosyası hazırlanıyor...',
    excelSuccess: 'Excel dosyası başarıyla indirildi',
    excelError: 'Dosya indirirken hata oluştu',
    statusUpdated: 'Proje durumu "{{status}}" olarak güncellendi',
    statusError: 'Durum güncellenirken hata oluştu',
    finished: 'Proje bitmiş olarak işaretlendi',
    unfinished: 'Projenin "bitti" işareti kaldırıldı',
    finishError: 'İşlem sırasında hata oluştu',
    testCreating: 'Test projesi oluşturuluyor...',
    testCreated: 'Test projesi ve tarifeleri başarıyla eklendi! {{count}} kişi için görev oluşturuldu.',
    testError: 'Test projesi eklenirken hata oluştu: {{message}}',
    screenFailError: 'Screen fail verileri yüklenirken hata oluştu',
  },
  screenFail: {
    title: 'Screen Fail Kayıtları',
    loading: 'Yükleniyor...',
    empty: 'Bu projede screen fail kaydı bulunmamaktadır.',
    total: 'Toplam Screen Fail',
    employees: 'Çalışan Sayısı',
    patients: 'Hasta Sayısı',
    date: 'Tarih',
    employee: 'Çalışan',
    patientId: 'Hasta ID',
    visitNumber: 'Vizit No',
    info: 'Bilgi',
  },
  statsModal: {
    title: 'Proje İstatistikleri',
    subtitle: '{{count}} proje',
    total: 'Toplam Proje',
    active: 'Aktif Projeler',
    inactive: 'Pasif Projeler',
    statusTitle: 'Proje Durumu Dağılımı',
    phaseTitle: 'Proje Aşaması Dağılımı',
    unspecified: 'Belirtilmemiş',
  },
  form: {
    addTitle: 'Yeni Proje Ekle',
    editTitle: 'Proje Düzenle',
    addSubtitle: 'Proje bilgilerini girin',
    submitAdd: 'Proje Ekle',
    submitEdit: 'Kaydet',
    sections: {
      general: 'Genel',
      generalHint: 'Müşteri, proje adları, protokol ve koordinatör',
      study: 'Çalışma',
      studyHint: 'Departman, aşama, tasarım, merkez ve tarihler',
      approvals: 'Onaylar',
      approvalsHint: 'Etik kurul ve Sağlık Bakanlığı onayları',
      finance: 'Finans',
      financeHint: 'Fatura, ödeme sıklığı ve kur sabitlemesi',
    },
    fields: {
      customer: 'Müşteri',
      titleShort: 'Proje Adı (Kısa)',
      titleLong: 'Proje Adı (Uzun)',
      protocolNumber: 'Protokol Numarası',
      coordinatorAcademician: 'Koordinatör Akademisyen',
      projectDepartment: 'Proje Departmanı',
      projectPhase: 'Proje Aşaması',
      projectDesign: 'Proje Design',
      projectCentersType: 'Proje Merkezi Tipi',
      center: 'Merkez',
      projectDate: 'Proje Tarihi',
      projectDueDate: 'Proje Bitiş Tarihi',
      ethicsCommitteeDate: 'Etik Kurul Tarihi',
      ethicsCommitteeNumber: 'Etik Kurul Numarası',
      ethicsCommitteePlace: 'Etik Kurul Yeri',
      sbFirstApprovalDate: 'SB İlk Onay Tarihi',
      sbFirstApprovalNumber: 'SB İlk Onay Numarası',
      sbProjectNumber: 'SB Proje Numarası',
      firstInvoiceDate: 'İlk Fatura Tarihi',
      paymentFrequency: 'Ödeme Sıklığı',
      isCurrencyFixed: 'Kur Sabitlemesi Yapıldı mı?',
      fixedCurrencyRate: 'Sabit Kur Değeri (Kaçtan?)',
    },
    placeholders: {
      customer: 'Müşteri seçiniz...',
      titleShort: 'Kısa başlık giriniz...',
      titleLong: 'Uzun başlık giriniz...',
      coordinator: 'Koordinatör akademisyen seçiniz...',
      department: 'Departman seçiniz...',
      phase: 'Aşama seçiniz...',
      design: 'Çift kör, open label veya hibrit...',
      centerType: 'Merkez tipi seçiniz...',
      center: 'Merkez seçiniz...',
      rate: 'Örn: 32.1500',
    },
    hints: {
      hybrid: 'Hibrit projede primer ve blinded çalışanın açtığı vizit, projeye bağlı unblinded çalışanın takvimine de otomatik düşer.',
      hybridEdit: 'Değişiklik yalnızca yeni vizitleri etkiler.',
      paymentFrequency: 'Müşteri seçilince müşteri kartındaki ödeme periyoduyla dolar',
    },
    centerTypes: {
      home: 'Ev',
      hospital: 'Hastane',
      concurrent: 'Eş Zamanlı',
    },
    errors: {
      required: 'Lütfen gerekli alanları doldurunuz!',
      rate: 'Sabit kur seçildi. Lütfen geçerli bir kur değeri giriniz.',
    },
    toast: {
      customersError: 'Müşteriler yüklenirken bir hata oluştu!',
      centersError: 'Merkezler yüklenirken bir hata oluştu!',
      personnelError: 'Harici personeller yüklenirken bir hata oluştu!',
      customerInfoError: 'Müşteri bilgileri alınırken bir hata oluştu!',
      added: 'Proje başarıyla eklendi! {{count}} kişi için görev oluşturuldu.',
      addError: 'Proje eklenirken bir hata oluştu!',
      updated: 'Proje başarıyla güncellendi!',
      updateError: 'Proje güncellenirken bir hata oluştu!',
    },
  },
  files: {
    title: 'Dosyalar',
    type: 'Dosya Türü',
    chooseType: 'Lütfen bir dosya türü seçin',
    typeFirst: 'Önce dosya türünü seçin',
    drop: 'Dosyanızı buraya sürükleyin',
    or: 'veya',
    browse: 'Dosya Seçin',
    uploading: 'Yükleniyor...',
    uploaded: '"{{name}}" yüklendi',
    uploadError: 'Dosya yükleme hatası',
    list_one: 'Yüklenmiş Dosyalar ({{count}})',
    list_other: 'Yüklenmiş Dosyalar ({{count}})',
    loading: 'Dosyalar yükleniyor...',
    none: 'Henüz dosya yüklenmemiş',
    open: 'Dosyayı aç',
    delete: 'Sil',
    keep: 'Vazgeç',
    confirmDelete: 'Silinsin mi?',
    deleted: 'Dosya başarıyla silindi',
    deleteError: 'Dosya silinirken hata oluştu: {{message}}',
    types: {
      ilkBakanlikOnayi: 'İlk Bakanlık Onayı',
      ilkEtikKurulOnayi: 'İlk Etik Kurul Onayı',
      etikKurulSunumu: 'Etik Kurul Sunumu',
      etikKurulKarari: 'Etik Kurul Kararı',
      etikKurulOnayi: 'Etik Kurul Onayı',
      titck: 'TİTCK',
      diger: 'Diğer',
    },
  },
  visits: {
    title: 'Ziyaret Bilgileri',
    add: 'Yeni Ziyaret Ekle',
    count_one: '{{count}} ziyaret',
    count_other: '{{count}} ziyaret',
    loading: 'Ziyaretler yükleniyor...',
    empty: 'Bu projeye ait ziyaret kaydı bulunamadı.',
    employee: 'Çalışan',
    firstVisitDate: 'İlk Ziyaret Tarihi',
    period: 'Periyot',
    patientId: 'Hasta ID',
    visitNumber: 'Vizit No',
    loadError: 'Ziyaret bilgileri yüklenirken hata oluştu!',
  },
  addVisit: {
    title: 'Yeni Visit Ekle',
    choose: 'Lütfen seçiniz',
    employee: 'Çalışan',
    patient: 'Hasta ID',
    patientOptional: 'Hasta Seçiniz (Opsiyonel)',
    patientsLoading: 'Hastalar yükleniyor...',
    noPatients: 'Bu projede kayıtlı hasta bulunamadı',
    visitDate: 'İlk Ziyaret Tarihi',
    visitType: 'Ziyaret Tipi',
    types: {
      hastane: 'Hastane Vizit',
      home: 'Home Vizit',
      telefon: 'Telefon Vizit',
      unplanning: 'Unplanning Vizit',
      handover: 'Handover Vizit',
    },
    window: 'Ziyaret Penceresi',
    windowStart: 'Başlangıç Tarihi',
    windowEnd: 'Bitiş Tarihi',
    windowVisit: 'Ziyaret:',
    windowDetail: 'Pencere: {{before}} gün önce başlar, {{after}} gün sonra biter (Toplam {{total}} gün)',
    visitNumber: 'Kaçıncı Visit',
    visitNumberPlaceholder: 'Örn: 1, 2, 3...',
    suggestedSame: 'Bu hastanın bu projedeki sıradaki viziti: {{n}}. İsterseniz değiştirebilirsiniz.',
    suggested: 'Önerilen: {{n}}',
    screenFail: 'Screen Fail mi?',
    screenFailNote: 'Screen fail olarak işaretlenen kayıtlar ziyaret olarak sayılmaz, yapılan iş olarak kaydedilir.',
    info: 'Bilgi',
    repeat: 'Tekrar Edecek Mi?',
    calendar: 'Bu ziyareti Google Takvimime ekle',
    endDate: 'Kapanış Visiti Tarihi',
    repeatPeriod: 'Tekrar Periyodu',
    repeatUnit: 'Tekrar birimi',
    units: {
      day: 'Gün',
      week: 'Hafta',
      month: 'Ay',
    },
    repeatHint: 'Her tekrarda vizit numarası bir artar. "Gün" seçildiğinde aralığa ziyaret penceresinin süresi de eklenir.',
    submit: 'Kaydet',
    submitting: 'İşleniyor...',
    errors: {
      dates: 'Lütfen tüm tarih alanlarını doldurun!',
      window: 'İlk ziyaret tarihi, başlangıç ve bitiş tarihleri arasında olmalıdır!',
      repeatPeriod: 'Tekrar periyodu 0’dan büyük olmalıdır!',
    },
    toast: {
      added: 'Visit(ler) başarıyla eklendi!',
      addError: 'Visit eklenirken bir hata oluştu!',
    },
  },
  patientStatus: {
    planned: 'Planlanan',
    screened: 'Screen Edilen',
    screenFail: 'Screen Fail',
    enrolled: 'Dahil Edilen',
    active: 'Aktif',
    onMedication: 'İlaç Alan',
    completed: 'Tamamlanan',
    withdrawn: 'Çekilen',
  },
  patientStatusHint: {
    planned: 'Çalışmaya dahil edilmesi planlanan',
    screened: 'Screening işlemi yapılan',
    screenFail: 'Screening başarısız olan',
    enrolled: 'Çalışmaya dahil edilen',
    active: 'Aktif olarak çalışmada olan',
    onMedication: 'İlaç tedavisi alan',
    completed: 'Çalışmayı tamamlayan',
    withdrawn: 'Çalışmadan çekilen',
  },
  patients: {
    title: 'Hasta Bilgileri',
    summary: 'Hasta Özeti',
    export: 'Excel İndir',
    add: 'Yeni Hasta Ekle',
    addFirst: 'İlk Hastayı Ekle',
    stats: {
      total: 'Toplam Hasta',
      active: 'Aktif Hasta',
      homeVisit: 'Home Visit',
    },
    visitDistribution: 'Aktif hastaların visit dağılımı:',
    visitN: 'Visit {{n}}',
    patientCount_one: '{{count}} hasta',
    patientCount_other: '{{count}} hasta',
    searchPlaceholder: 'Hasta ID ara...',
    statusFilter: 'Durum filtresi',
    allStatuses: 'Tüm Durumlar',
    loading: 'Hastalar yükleniyor...',
    noMatch: 'Filtrelere uygun hasta bulunamadı.',
    empty: 'Bu projeye ait hasta kaydı bulunamadı.',
    showing: '{{shown}} / {{total}} hasta gösteriliyor',
    patientId: 'Hasta ID',
    status: 'Durum',
    enrollmentDate: 'Kayıt Tarihi',
    enrollmentShort: 'Kayıt',
    firstDoseDate: 'İlk Doz Tarihi',
    currentVisit: 'Mevcut Visit',
    homeVisit: 'Home Visit',
    homeVisitDates: 'Home Visit Tarihleri',
    homeVisitInfo: 'Home Visit Bilgisi',
    notes: 'Notlar',
    actions: 'İşlemler',
    view: 'Detayları Görüntüle',
    edit: 'Düzenle',
    delete: 'Sil',
    detailTitle: 'Hasta Detayları',
    deleteTitle: 'Hastayı Sil',
    deleteMessage: '{{id}} hastasını silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
    deleteConfirm: 'Evet, Sil',
    toast: {
      loadError: 'Hasta bilgileri yüklenirken hata oluştu!',
      deleted: 'Hasta başarıyla silindi',
      deleteError: 'Hasta silinirken hata oluştu',
      excelSuccess: 'Excel dosyası başarıyla indirildi',
      excelError: 'Excel dosyası oluşturulurken hata oluştu',
    },
  },
  addPatient: {
    addTitle: 'Yeni Hasta Ekle',
    editTitle: 'Hasta Bilgilerini Düzenle',
    save: 'Kaydet',
    update: 'Güncelle',
    basics: 'Temel Bilgiler',
    patientId: 'Hasta ID',
    patientIdPlaceholder: 'Örn: PAT-001',
    status: 'Durum',
    dates: 'Tarih Bilgileri',
    enrollmentDate: 'Kayıt Tarihi (Enrollment Date)',
    firstDoseDate: 'İlk Doz Tarihi (POF)',
    recommended: 'önerilen',
    currentVisitNumber: 'Mevcut Visit Numarası',
    currentVisitPlaceholder: 'Örn: 3',
    homeVisit: 'Home Visit Bilgileri',
    homeVisitDone: 'Home Visit Yapıldı',
    homeVisitDate: 'Home Visit Tarihi',
    addDate: 'Tarih Ekle',
    addedDates: 'Eklenen Tarihler:',
    removeDate: '{{date}} tarihini kaldır',
    homeVisitInfo: 'Home Visit Notları',
    homeVisitInfoPlaceholder: 'Home visit ile ilgili ek bilgiler...',
    notes: 'Ek Notlar',
    notesPlaceholder: 'Hasta ile ilgili ek notlar, önemli bilgiler...',
    errors: {
      patientId: 'Hasta ID zorunludur',
      status: 'Durum seçimi zorunludur',
      enrollmentDate: 'Bu durum için kayıt tarihi gereklidir',
      firstDoseDate: 'İlaç alan hasta için ilk doz tarihi önerilir',
      inUse: 'Bu Hasta ID zaten kullanımda',
    },
    existing: {
      title: 'Bu hasta zaten kayıtlı',
      body: '{{id}} bu projede zaten kayıtlı. Yeni bir kayıt oluşturmak yerine mevcut hastayı kullanmak ister misiniz?',
      note: 'Mevcut hasta bilgileri değiştirilmez, hasta yalnızca sizin listenize eklenir.',
      cancel: 'Vazgeç',
      use: 'Mevcut Hastayı Kullan',
      linking: 'Ekleniyor...',
    },
    toast: {
      chooseDate: 'Lütfen bir tarih seçin',
      dateExists: 'Bu tarih zaten eklenmiş',
      linked: 'Mevcut hasta listenize eklendi',
      linkError: 'Hasta listenize eklenirken hata oluştu',
      fixErrors: 'Lütfen zorunlu alanları doldurun',
      duplicate: 'Bu Hasta ID bu projede zaten mevcut!',
      updated: 'Hasta bilgileri başarıyla güncellendi',
      added: 'Hasta başarıyla eklendi',
      updateError: 'Hasta güncellenirken hata oluştu',
      addError: 'Hasta eklenirken hata oluştu',
    },
  },
  roles: {
    'backup-personeli': 'Backup Personeli',
    cra: 'CRA',
    'calisma-baslatma': 'Çalışma Başlatma Sorumlusu',
    'egitim-sorumlusu': 'Eğitim Sorumlusu',
    'finans-uzmani': 'Finans Uzmanı',
    'ik-uzmani': 'IK Uzmanı',
    'it-uzmani': 'IT Uzmanı',
    'is-gelistirme': 'İş Geliştirme Uzmanı',
    'kalite-muduru': 'Kalite Müdürü',
    'klinik-hemsire': 'Klinik Araştırma Hemşiresi',
    'proje-muduru': 'Proje Müdürü',
    'saha-koordinatoru': 'Saha Koordinatörü',
    'saha-koordinatoru-sorumlusu': 'Saha Koordinatörü Sorumlusu',
    'smo-lead': 'SMO Lead',
  },
  workers: {
    title: 'Proje Çalışanları',
    export: 'Tabloyu İndir',
    add: 'Projeye Çalışan Ekle',
    addFirst: 'İlk Çalışanı Ekle',
    summary: 'Çalışan özeti',
    stats: {
      total: 'Toplam Çalışan',
      active: 'Aktif',
      passive: 'Pasif',
      left: 'Ayrıldı',
    },
    status: {
      active: 'Aktif',
      passive: 'Pasif',
      left: 'Ayrıldı',
    },
    searchPlaceholder: 'Çalışan ara...',
    loading: 'Çalışanlar yükleniyor...',
    empty: 'Bu projede henüz çalışan bulunmamaktadır.',
    noMatch: 'Aramanızla eşleşen hiç çalışan yok',
    showing: '{{shown}} / {{total}} çalışan gösteriliyor',
    selectHint: 'Ayrıntıları ve işlemleri görmek için listeden bir çalışan seçin.',
    columns: {
      name: 'Ad',
      surname: 'Soyad',
      roles: 'Roller',
      centers: 'Merkezler',
      assignedAt: 'Atanma Tarihi',
      status: 'Durum',
    },
    centerCount_one: '{{count}} merkez',
    centerCount_other: '{{count}} merkez',
    leftCount_one: '{{count}} ayrıldı',
    leftCount_other: '{{count}} ayrıldı',
    leftHint: 'Ayrıldığı merkezlerin kayıtları korunuyor',
    detail: {
      title: 'Çalışan Detayı',
      activeCenters: 'Merkez Sayısı',
      roleCount: 'Rol Sayısı',
      totalAssignments: 'Toplam Atama',
      assignedAt: 'Atanma Tarihi',
      roles: 'Roller',
      assignments: 'Merkezler ve Roller',
      info: 'Bilgi',
      unknownCenter: 'Bilinmeyen Merkez',
      leftOn: 'Ayrıldı ({{date}})',
    },
    actions: {
      edit: 'Düzenle',
      upload: 'Dosya Yükle',
      remove: 'Projeden Tamamen Çıkar',
      removeHint: 'Çalışanın bu projedeki tüm atamalarını kalıcı olarak siler',
    },
    remove: {
      title: 'Projeden Tamamen Çıkar',
      lead: '{{name}} adlı çalışanın {{project}} projesindeki tüm atamaları kalıcı olarak silinecek:',
      warning: 'Bu işlem geri alınamaz: atama satırlarıyla birlikte o satırlara bağlı tarife ve dosya kayıtları da kaybolur. Çalışanın projede görünmesini istemiyorsanız ancak geçmişi korumak istiyorsanız "Düzenle" ekranından pasife alın veya merkezden ayrılmış olarak işaretleyin.',
      cancel: 'Vazgeç',
      confirm: 'Kalıcı Olarak Sil',
      removing: 'Siliniyor...',
    },
    toast: {
      loadError: 'Çalışan bilgileri yüklenirken hata oluştu!',
      tariffsError: 'Tarife listesi yüklenirken hata oluştu!',
      centersError: 'Merkez listesi yüklenirken hata oluştu!',
      dataError: 'Veri yüklenirken hata oluştu!',
      managerExists: 'Bu merkez için daha önceden bir sorumlu atanmış!',
      required: 'Lütfen gerekli alanları doldurunuz!',
      alreadyAssigned: 'Bu çalışan zaten bu projede çalışıyor!',
      added: 'Çalışan başarıyla projeye eklendi!',
      addError: 'Çalışan eklenirken bir hata oluştu!',
      updated: 'Çalışan bilgileri başarıyla güncellendi!',
      updateError: 'Çalışan güncellenirken bir hata oluştu!',
      projectMissing: 'Proje kaydı bulunamadı!',
      removed: '{{name}} projeden tamamen çıkarıldı.',
      removeError: 'Çalışan projeden çıkarılırken bir hata oluştu!',
    },
  },
  workerForm: {
    addTitle: 'Projeye Çalışan Ekle',
    editTitle: 'Çalışan Bilgilerini Düzenle',
    employee: 'Çalışan',
    employeePlaceholder: 'Çalışan seçin veya arayın',
    roles: 'Roller',
    rolesPlaceholder: 'Lütfen rol seçiniz',
    roleSearch: 'Rol ara...',
    rolesSelected_one: '{{count}} rol seçildi',
    rolesSelected_other: '{{count}} rol seçildi',
    centers: 'Merkezler',
    centersPlaceholder: 'Lütfen merkez seçiniz',
    centerSearch: 'Merkez ara...',
    centersSelected_one: '{{count}} merkez seçildi',
    centersSelected_other: '{{count}} merkez seçildi',
    deletedCenter: 'Silinmiş',
    selectedCenters: 'Seçilen Merkezler',
    removeCenter: '{{name}} merkezini kaldır',
    archiveCenter: '{{name}} merkezinden ayrıldı olarak işaretle',
    archiveCenterHint: 'Bu merkezden ayrıldı olarak işaretle',
    fteNote: 'FTE yönetimi için Çalışan Analizi sayfasını kullanın',
    archivedCenters: 'Ayrıldığı Merkezler',
    unknownCenter: 'Bilinmeyen Merkez',
    leftOn: 'Ayrıldı · {{date}}',
    willLeave: 'Ayrılacak',
    restoreCenter: '{{name}} merkezini geri ekle',
    archivedNote: 'Bu merkezlerdeki geçmiş kayıtlar, yüklenen dosyalar ve FTE bilgileri korunur.',
    workerType: 'Çalışan Tipi',
    primer: 'Primer',
    backup: 'Backup',
    blindStatus: 'Kör Çalışma Durumu',
    blinded: 'Blinded',
    unblinded: 'Unblinded',
    status: 'Durum',
    info: 'Bilgi',
    infoPlaceholder: 'Ek bilgi giriniz...',
    managerWarning: 'Bu merkez ve rol için zaten bir çalışan atanmış!',
    add: 'Çalışan Ekle',
    adding: 'Ekleniyor...',
    update: 'Güncelle',
    updating: 'Güncelleniyor...',
  },
  workerFiles: {
    title: 'Sunum Dosyaları',
    type: 'Sunum',
    center: 'Merkez',
    centerHint: 'Dosya bu merkezdeki atamaya eklenir',
    drop: 'Sunum dosyanızı buraya sürükleyin',
    list_one: 'Yüklenmiş Sunum Dosyaları ({{count}})',
    list_other: 'Yüklenmiş Sunum Dosyaları ({{count}})',
  },
  card: {
    title: 'Proje Kartı',
    edit: 'Düzenle',
    summary: 'Özet',
    activeWorkers: 'Aktif Çalışan',
    centers: 'Merkez',
    patients: 'Hasta',
    visits: 'Ziyaret',
    info: 'Proje Bilgileri',
    code: 'Proje Kodu',
    name: 'Proje Adı',
    approval: 'Onay ve Etik Kurul',
    finance: 'Finans Bilgileri',
    fixedRate: 'Sabit Kur',
    centersTitle: 'Merkezler ({{count}})',
    noCenters: 'Projeye bağlı merkez kaydı bulunmuyor.',
    loadError: 'Proje kartı bilgileri yüklenemedi',
  },
};

export default projectManagement;
